import { Attributes, Parameter, Parameters } from '../../../models/index';
import { UseCase } from '../../UseCase';
import { SetParameter } from './SetParameter';

export namespace SetAttributeParameter {
    export interface Params<P extends string> {
        attributes?: Attributes<Parameters<P>>;
    }
}

export class SetAttributeParameter<P extends string>
    implements UseCase<SetAttributeParameter.Params<P>, Attributes<Parameters<P>>>
{
    private setParameter = new SetParameter<P>();

    execute({ attributes }: SetAttributeParameter.Params<P>): Attributes<Parameters<P>> {
        attributes = attributes || {};
        attributes.attributes = attributes.attributes || {};
        this.setParameter.execute({ params: attributes.attributes });
        return attributes;
    }
}
